import { render, staticRenderFns } from "./order-hall.vue?vue&type=template&id=3708e848&scoped=true&"
import script from "./order-hall.vue?vue&type=script&lang=js&"
export * from "./order-hall.vue?vue&type=script&lang=js&"
import style0 from "./order-hall.vue?vue&type=style&index=0&id=3708e848&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3708e848",
  null
  
)

export default component.exports